/* eslint-disable */

export enum PaymentPushState {
  /**
   * PENDING - Obsolete. Replaced by PUSHING.
   *
   * @deprecated
   */
  PENDING = "PENDING",
  /** WAITING_TO_PUSH - The push has been planned but has not yet started. */
  WAITING_TO_PUSH = "WAITING_TO_PUSH",
  /** PUSHING - The push has started. */
  PUSHING = "PUSHING",
  /**
   * WAITING_FOR_SEND - This is considered a successful push for PAYING_OUT or REFUNDING state, but this might fail
   * later asynchronously. This state is used only for ACH pushes and corresponds to the Teller
   * money transfer states: STAGED, PENDING, or SENT.
   */
  WAITING_FOR_SEND = "WAITING_FOR_SEND",
  /**
   * SENT - Money has been pushed.
   * If this state is used for ACH pushes, then it corresponds to the Teller money transfer states:
   * TENTATIVELY_SUCCEEDED or SUCCEEDED.
   */
  SENT = "SENT",
  /** PUSH_FAILED - Push failed. See the reason in PaymentPush.failure_reason. */
  PUSH_FAILED = "PUSH_FAILED",
  /**
   * FAILED - The push has failed hard. The customer will need to take action to rectify the problem.
   * Deprecated: This will be replaced soon by PUSH_FAILED with an appropriate failure_reason.
   *
   * @deprecated
   */
  FAILED = "FAILED",
  /**
   * FAILED_UNSUPPORTED - This mechanism doesn't support this payment.
   * Deprecated: This will be replaced soon by PUSH_FAILED with an appropriate failure_reason.
   *
   * @deprecated
   */
  FAILED_UNSUPPORTED = "FAILED_UNSUPPORTED",
  /** FAILED_RETRY_LATER - The mechanism couldn't confirm money movement. Retry after a delay. */
  FAILED_RETRY_LATER = "FAILED_RETRY_LATER",
  /**
   * FAILED_CANCELED - The push is canceled because the motivating payment has been canceled.
   * Deprecated: This will be replaced soon by PUSH_FAILED with an appropriate failure_reason.
   *
   * @deprecated
   */
  FAILED_CANCELED = "FAILED_CANCELED",
  /**
   * NEEDS_HUMAN_INTERVENTION - The push is in an indeterminate state, an engineer must manually resolve this push before
   * the payment can proceed.
   */
  NEEDS_HUMAN_INTERVENTION = "NEEDS_HUMAN_INTERVENTION",
  /**
   * UNLINKED_REFUND_ASYNCHRONOUSLY_FAILED - Unlinked refund asynchronously failed. Due to quirks in Wells reporting, these come to us
   * in the form of chargebacks with a negative dispute amount. While these payments are reported
   * through the chargebacks systems, they have nothing to do with real chargebacks.
   */
  UNLINKED_REFUND_ASYNCHRONOUSLY_FAILED = "UNLINKED_REFUND_ASYNCHRONOUSLY_FAILED",
}
